/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 이미지 목록을 목록형태로 변환하는 툴을 정의한다.
 *
 * @file /src/rootin/blocks/images/tools/List.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 7. 19.
 */
import { Tool } from '@rootin/base/Tool';
import { Block } from '@rootin/base/Block';
import { Element } from '@rootin/base/Element';
import { Language, LanguageText } from '@utils/Language';
import { Images } from '../Images';

export class List extends Tool {
    /**
     * 툴타입
     */
    static type: string = 'list';

    /**
     * 툴그룹
     */
    static group: string = 'images-mode';

    /**
     * 툴아이콘
     */
    icon: string =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-gallery-vertical-icon lucide-gallery-vertical"><path d="M3 2h18"/><rect width="18" height="12" x="3" y="6" rx="2"/><path d="M3 22h18"/></svg>';

    /**
     * 툴팁
     */
    text: LanguageText = Language.get('rootin.blocks.images.tools.list');

    /**
     * 툴 클릭시 실행할 핸들러를 정의한다.
     */
    handler(): void {
        const block = this.editor.focus.getBlock().getParents('images') as Images;
        if (block !== null) {
            block.setMode(this.getType());
        }
    }

    /**
     * 툴의 표시여부 조건을 설정한다.
     * @todo 커서가 편집 가능한 유닛 안이거나 다중 유닛이 선택돼 있을 때만 노출할지 고민한다.
     *
     * @param block - 커서가 위치한 블록
     * @param element - 커서가 위치한 편집유닛
     * @returns 표시여부
     */
    visible(block: Block | null, element: Element | null): boolean {
        return block.getParents('images') !== null;
    }

    /**
     * 툴이 활성여부 조건을 설정한다.
     *
     * @returns 활성여부
     */
    active(): boolean {
        const block = this.editor.focus.getBlock().getParents('images') as Images;
        if (block !== null) {
            const mode = block.$getBlock().getAttr('data-mode');
            return mode == this.getType();
        }

        return false;
    }
}
